import { NoData, RenderWhen, TableDisplayTitle, Time } from "@components";
import ResourceLink from "@modules/graph-explorer/components/common/links/ResourceLink";
import type { EnrichedPassiveDns } from "@modules/network/@types/Domain";
import ThirdPartyReputationStats from "@modules/network/components/common/ThirdPartyReputationStats";
import type { Schema } from "@modules/samples/@types";

export const schema: Schema<EnrichedPassiveDns> = {
  fields: [
    {
      name: "first_seen",
      displayTitle: (
        <TableDisplayTitle className="bold">First Seen</TableDisplayTitle>
      ),
      sortable: false,
      component: ({ first_seen }) => (
        <RenderWhen condition={Boolean(first_seen)} fallback={<NoData />}>
          <Time withTitle time={first_seen} format="SHORT_ISO_18061" />
        </RenderWhen>
      ),
      style: { padding: "10px", width: "15%" },
      className: "overflow-ellipsis"
    },
    {
      name: "last_seen",
      displayTitle: (
        <TableDisplayTitle className="bold">Last Seen</TableDisplayTitle>
      ),
      sortable: false,
      component: ({ last_seen }) => (
        <RenderWhen condition={Boolean(last_seen)} fallback={<NoData />}>
          <Time withTitle time={last_seen} format="SHORT_ISO_18061" />
        </RenderWhen>
      ),
      style: { padding: "10px", width: "15%" },
      className: "overflow-ellipsis"
    },
    {
      name: "type",
      displayTitle: (
        <TableDisplayTitle className="bold">Type</TableDisplayTitle>
      ),
      sortable: false,
      component: ({ type }) => (
        <RenderWhen condition={Boolean(type)}>{type}</RenderWhen>
      ),
      style: { padding: "10px", width: "15%" },
      className: "overflow-ellipsis"
    },
    {
      name: "value",
      displayTitle: (
        <TableDisplayTitle className="bold">Value</TableDisplayTitle>
      ),
      sortable: false,
      className: "overflow-ellipsis",
      component: ({ value }) => <ResourceLink value={value ?? ""} />,
      style: { padding: "10px", width: "35%" }
    },
    {
      name: "detections",
      displayTitle: (
        <TableDisplayTitle className="bold">Detections</TableDisplayTitle>
      ),
      sortable: false,
      component: ({ reputation }) => (
        <ThirdPartyReputationStats
          maliciousCount={reputation?.malicious ?? 0}
          totalCount={reputation?.total ?? 0}
        />
      ),
      style: { padding: "10px", width: "20%" },
      className: "overflow-ellipsis"
    }
  ]
};
